<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="onePs.is_ecommerce == 'loading'" class="sloader"></div>
		<div v-else>
			<feather-icon
				v-if="onePs.is_ecommerce == 'true'"
				icon="ShoppingBagIcon"
				class="m-0 cursor-pointer"
				style="color: #e94f1b"
			/>
			<div v-else>Non</div>
		</div>
	</div>
</template>
  
  <script>
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>